<template>
  <el-card>
    <el-row class="feedback__title">反馈系统</el-row>
    <!-- 搜索 -->
    <el-row class="feedback__search">
      <span>rid</span>
      <el-input
        v-model="search.rid"
        placeholder="请输入内容"
        style="width: 200px; margin-bottom: 5px"
      ></el-input>
      <span>渠道</span>
      <el-select
        v-model="search.channel"
        clearable
        filterable
        placeholder="请选择"
      >
        <el-option
          v-for="item in channelList"
          :key="item.channelId"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span>回复状态</span>
      <el-select
        v-model="search.feedbackStatus"
        clearable
        filterable
        placeholder="请选择"
      >
        <el-option
          v-for="item in feedbackStatusList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span>用户评价</span>
      <el-select
        v-model="search.userEvaluate"
        clearable
        filterable
        placeholder="请选择"
      >
        <el-option
          v-for="item in userEvaluateList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span>反馈分类</span>
      <el-select
        v-model="search.category"
        clearable
        filterable
        placeholder="请选择"
      >
        <el-option
          v-for="item in categoryList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        style="margin-left: 10px"
        type="success"
        @click="getAllFeedback(0)"
        >搜索</el-button
      >
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-table border :data="tableList">
        <el-table-column prop="id" label="id" align="center"> </el-table-column>
        <el-table-column prop="rid" label="rid" align="center">
        </el-table-column>
        <el-table-column prop="email" label="邮箱" align="center">
        </el-table-column>
        <el-table-column prop="feedbackTitle" label="反馈标题" align="center">
        </el-table-column>
        <el-table-column prop="secTitle" label="二级标题" align="center">
        </el-table-column>
        <el-table-column prop="textContent" label="反馈文字内容" align="center">
        </el-table-column>
        <el-table-column prop="replyContent" label="回复内容" align="center">
        </el-table-column>
        <el-table-column prop="channel" label="渠道" align="center">
        </el-table-column>
        <!-- <el-table-column label="回复内容图片" align="center">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: auto"
              :src="scope.row.replyPicture"
              :preview-src-list="[scope.row.replyPicture]"
            ></el-image>
          </template>
        </el-table-column> -->
        <el-table-column label="用户评价" align="center">
          <template slot-scope="scope">
            {{ (userEvaluateList[scope.row.userEvaluate + 1] && userEvaluateList[scope.row.userEvaluate + 1].label) || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="身份 " align="center">
          <template slot-scope="scope">
            {{ scope.row.gender === 1 ? '用户' : '主播' }}
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center" width="500">
          <template slot-scope="scope">
            <div class="imgList">
              <el-image
                v-for="(item, index) in scope.row.feedbackPicList"
                :key="index"
                :src="item"
                :preview-src-list="scope.row.feedbackPicList"
                style="
                  flex: 0 0 auto;
                  width: 100px;
                  height: 100px;
                  margin-right: 10px;
                "
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="回复图片" align="center" width="500">
          <template slot-scope="scope">
            <div class="imgList">
              <el-image
                v-for="(item, index) in scope.row.replyPictureList"
                :key="index"
                :src="item"
                :preview-src-list="scope.row.replyPictureList"
                style="
                  flex: 0 0 auto;
                  width: 100px;
                  height: 100px;
                  margin-right: 10px;
                "
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="反馈时间" align="center">
        </el-table-column>
        <el-table-column prop="fixTime" label="处理时间" align="center">
        </el-table-column>
        <el-table-column label="反馈分类" align="center">
          <template slot-scope="scope">
            {{ (categoryList[scope.row.category] && categoryList[scope.row.category].label) || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.replyStatus === 0 ? '未回复' : '已回复' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="reply(scope.row)"
              >查看详情</el-button
            >
            <el-button
              v-if="
                scope.row.feedbackVideoList &&
                scope.row.feedbackVideoList.length > 0
              "
              type="primary"
              size="small"
              @click="openNewLink(scope.row.feedbackVideoList[0])"
              >查看视频</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalPage"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @current-change="guaranteedHandleCurrentChange"
      >
      </el-pagination>
    </el-row>
    <!-- 弹窗 -->
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="dailogShow"
      title="反馈详情"
      width="800px"
    >
      <div class="feedback-detail">
        <!-- 状态标签 -->
        <div class="detail-header">
          <el-tag
            :type="form.replyStatus === 0 ? 'warning' : 'success'"
            size="medium"
            style="font-size: 14px;"
          >
            {{ form.replyStatus === 0 ? '待处理' : '已回复' }}
          </el-tag>
        </div>

        <!-- 基本信息区域 -->
        <el-card class="detail-card" shadow="never">
          <div slot="header" class="card-header">
            <span>基本信息</span>
          </div>
          <el-row :gutter="20" class="detail-row">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">用户RID:</span>
                <span class="detail-value">{{ form.rid || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">反馈时间:</span>
                <span class="detail-value">{{ form.createTime || '-' }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="detail-row">
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">反馈邮箱:</span>
                <span class="detail-value">{{ form.email || '-' }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="detail-item">
                <span class="detail-label">身份:</span>
                <span class="detail-value">{{ form.gender === 1 ? '用户' : '主播' }}</span>
              </div>
            </el-col>
          </el-row>
        </el-card>

        <!-- 反馈内容区域 -->
        <el-card class="detail-card" shadow="never">
          <div slot="header" class="card-header">
            <span>反馈内容</span>
          </div>
          <div class="detail-row">
            <div class="detail-item">
              <span class="detail-label">反馈标题:</span>
              <span class="detail-value">{{ form.feedbackTitle || '-' }}</span>
            </div>
          </div>
          <div class="detail-row" v-if="form.secTitle">
            <div class="detail-item">
              <span class="detail-label">二级标题:</span>
              <span class="detail-value">{{ form.secTitle }}</span>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-item">
              <span class="detail-label">反馈分类:</span>
              <el-tag
                type="info"
                size="small"
                style="margin-left: 8px;"
              >
                {{ (categoryList[form.category] && categoryList[form.category].label) || '-' }}
              </el-tag>
            </div>
          </div>
          <div class="detail-row">
            <div class="detail-item detail-item-full">
              <span class="detail-label">反馈描述:</span>
              <div class="detail-value detail-description">{{ form.textContent || '-' }}</div>
            </div>
          </div>
        </el-card>

        <!-- 反馈图片区域 -->
        <el-card class="detail-card" shadow="never" v-if="form.feedbackPicList && form.feedbackPicList.length > 0">
          <div slot="header" class="card-header">
            <span>反馈图片</span>
          </div>
          <div class="imgs">
            <div class="imgs__item" v-for="(item,index) in form.feedbackPicList" :key="index">
              <el-image
                style="width: 120px; height: 120px; border-radius: 4px; cursor: pointer;"
                :src="item"
                :preview-src-list="form.feedbackPicList"
                fit="cover"
              >
              </el-image>
            </div>
          </div>
        </el-card>

        <!-- 反馈视频区域 -->
        <el-card class="detail-card" shadow="never" v-if="form.feedbackVideoList && form.feedbackVideoList.length > 0">
          <div slot="header" class="card-header">
            <span>反馈视频</span>
          </div>
          <div class="videos">
            <div class="videos__item" v-for="(item,index) in form.feedbackVideoList" :key="index">
              <div class="video-wrapper" @click="openNewLink(item)">
                <video
                  style="width: 120px; height: 120px; border-radius: 4px; cursor: pointer; object-fit: cover;"
                  :src="item"
                  controls
                >
                </video>
                <div class="video-play-icon">▶</div>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 回复区域 -->
        <el-card class="detail-card" shadow="never">
          <div slot="header" class="card-header">
            <span>回复内容</span>
          </div>
          <el-form ref="Form" :rules="rules" :model="form">
            <el-form-item prop="replyContent">
              <el-input
                type="textarea"
                v-model="form.replyContent"
                :rows="4"
                placeholder="请输入回复内容"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-upload
                class="upload-demo"
                action="#"
                :on-change="changfile"
                :on-remove="handleRemove"
                list-type="picture-card"
                :file-list="fileList"
                :auto-upload="false"
                :multiple="true"
              >
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">支持上传多张图片，单张图片不超过5MB</div>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button @click="resetForm">取消</el-button>
              <el-button type="primary" @click="submit('Form')">确认回复</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      search: {
        rid: null,
        channel: null,
        feedbackStatus: null,
        userEvaluate: null,
        category: null,
      },
      // 弹出框是否显示
      dailogShow: false,
      // 每页显示数量
      pageSize: 30,
      // 总页数
      totalPage: 10,
      // 当前页数
      currentPage: 0,
      // 渠道列表
      channelList: [],
      // 表单数据
      tableList: [],
      // 表单规则
      rules: {
        replyContent: [
          { required: true, message: '请填写回复内容', trigger: 'blur' },
        ],
      },
      form: {
        feedbackId: null,
        replyContent: null,
        replyPictureList: [],
      },
      fileList: [],
      feedbackStatusList: [
        {
          label: 'all',
          value: '',
        },
        {
          label: '未回复',
          value: 0,
        },
        {
          label: '已回复',
          value: 1,
        },
      ],
      userEvaluateList: [
        {
          label: 'all',
          value: '',
        },
        {
          label: '未填写',
          value: 0,
        },
        {
          label: '未解决',
          value: 1,
        },
        {
          label: '已解决',
          value: 2,
        },
      ],
      categoryList: [
        {
          label: '默认',
          value: 0,
        },
        {
          label: '主播相关',
          value: 1,
        },
        {
          label: '代理相关',
          value: 2,
        },
        {
          label: '币商相关',
          value: 3,
        },
        {
          label: 'BD相关',
          value: 4,
        },
      ],
    }
  },
  mounted() {
    this.getAllPullDown()
  },
  methods: {
    resetForm() {
      this.fileList = []
      this.form = {
        feedbackId: null,
        replyContent: null,
        replyPicList: [],
        category: null,
      }
      this.dailogShow = false
    },
    // 查看视频
    async openNewLink(value) {
      window.open(value)
    },
    // 回复
    reply(info) {
      let data = JSON.parse(JSON.stringify(info))
      this.form = { ...data }
      this.form.feedbackId = data.id
      this.form.replyPicList = data.replyPictureList || []
      if (this.form.replyPicList.length > 0) {
        this.form.replyPicList.forEach((item) => {
          let last = item.lastIndexOf('/')
          this.fileList.push({
            name: item.substring(last + 1),
            url: item,
          })
        })
      }
      console.log(this.fileList)
      this.dailogShow = true
    },
    // 提交
    submit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$axios({
            method: 'POST',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
            url: this.$store.getters.path.feedback_reply,
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token,
            },
            data: this.form,
          })
          if (res.code !== 0) {
            return this.$message.error('提交失败')
          } else {
            this.dailogShow = false
            this.resetForm()
            this.getAllFeedback()
            this.$message.success('回复成功')
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 删除图片
    handleRemove(file) {
      let index = this.fileList.findIndex((item) => item.name == file.name)
      this.fileList.splice(index, 1)
      this.form.replyPicList.splice(index, 1)
    },
    //上传图片
    async changfile(file) {
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      formdata.append('dir', 'feedback_reply_pic/icon/')
      console.log(file.raw)
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        formdata
      )

      if (res.code !== 0) {
        this.fileList = []
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      this.form.replyPicList.push(res.data)
      this.fileList.push({
        name: file.name,
        url: res.data,
      })
    },
    //修改当前页
    guaranteedHandleCurrentChange(page) {
      this.getAllFeedback(page)
    },
    //获取所有数据
    getAllPullDown() {
      this.getChannel()
      this.getAllFeedback(0)
    },
    // 获取所有表格数据
    async getAllFeedback(page) {
      let pages = page || this.currentPage
      let info = {
        ...this.search,
        page: pages,
      }

      const { data: res } = await this.$axios({
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.feedback_list,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          ...info,
        },
      })

      if (res.code !== 0) {
        return this.$message.error(res.msg)
      } else {
        this.totalPage = res.data.total
        this.tableList = res.data.data
      }
    },
    //获取渠道选项
    async getChannel() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.channelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.channelList = [
          { channelId: -1, name: 'all', value: 'all' },
          ...res.data,
        ]
      }
    },
    // 格式化时间
    formatDate(row, column, time, type = true) {
      let data
      console.log(time)
      // 获取单元格数据
      if (type) {
        data = row[column.property] * 1000
      } else {
        data = time * 1000
      }
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() + 1) +
        '-' +
        dt.getDate() +
        ' ' +
        dt.getHours() +
        ':' +
        dt.getMinutes() +
        ':' +
        dt.getSeconds()
      )
    },
  },
}
</script>

<style scoped lang="scss">
.feedback {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }

    .searchBtn {
      margin-left: 10px;
    }
  }
}

.imgList {
  display: flex;
  flex-wrap: nowarp;
  img {
    flex: 0 0 auto;
  }
}

.imgs{
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  gap: 10px;
}

// 反馈详情弹窗样式
.feedback-detail {
  .detail-header {
    margin-bottom: 20px;
    text-align: center;
  }

  .detail-card {
    margin-bottom: 20px;
    border: 1px solid #e4e7ed;

    .card-header {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      padding: 0;
    }
  }

  .detail-row {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .detail-item {
    display: flex;
    align-items: center;
    min-height: 32px;

    &.detail-item-full {
      flex-direction: column;
      align-items: flex-start;
    }

    .detail-label {
      font-weight: 600;
      color: #606266;
      min-width: 100px;
      margin-right: 12px;
      white-space: nowrap;
    }

    .detail-value {
      color: #303133;
      flex: 1;
      word-break: break-word;

      &.detail-description {
        margin-top: 8px;
        padding: 12px;
        background-color: #f5f7fa;
        border-radius: 4px;
        line-height: 1.6;
        white-space: pre-wrap;
        width: 100%;
      }
    }
  }

  .imgs {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .imgs__item {
      position: relative;
      border-radius: 4px;
      overflow: hidden;
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .videos {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .videos__item {
      position: relative;
      border-radius: 4px;
      overflow: hidden;

      .video-wrapper {
        position: relative;
        cursor: pointer;
        transition: transform 0.2s;

        &:hover {
          transform: scale(1.05);
        }

        .video-play-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 24px;
          color: #fff;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
          pointer-events: none;
        }
      }
    }
  }

  .upload-demo {
    .el-upload__tip {
      margin-top: 8px;
      color: #909399;
      font-size: 12px;
    }
  }
}
</style>
